import React, { useState, useMemo } from "react";
import "./style.scss";

/**
 * 
 *
 * Props:
 * items: [
 *   {
 *     id: string,
 *     title: string,
 *     description: string | ReactNode,
 *     defaultExpanded?: boolean
 *   }
 * ]
 * allowMultiple?: boolean (default false)
 */
export default function Accordion({ items = [], allowMultiple = false , isDarkMode=false ,isWeb=false }) {
  const defaultExpanded = useMemo(() => {
    if (!items.length) return allowMultiple ? [] : null;
    if (allowMultiple) return items.filter(i => i.defaultExpanded).map(i => i.id);
    const first = items.find(i => i.defaultExpanded);
    return first ? first.id : items[0].id;
  }, [items, allowMultiple]);

  const [expanded, setExpanded] = useState(defaultExpanded);

  const toggle = (id) => {
    if (allowMultiple) {
      setExpanded(prev =>
        prev.includes(id) ? prev.filter(p => p !== id) : [...prev, id]
      );
    } else {
      setExpanded(prev => (prev === id ? null : id));
    }
  };

  const isOpen = (id) =>
    allowMultiple ? expanded.includes(id) : expanded === id;

  return (
    <div className={`dynamicAccordion ${isWeb ?'browser':''} ${isDarkMode ?'dark-mode':''}`}>
      {items.map((item,index) => (
        <div key={item.id} className={`dynamicAccordion__item ${index === (items.length -1 )?'last__item':'' } ${index === 0 ?'first__item':''} ${isOpen(item.id) ? "open" : ""}`}>
          <button
            className="dynamicAccordion__header"
            onClick={() => toggle(item.id)}
            aria-expanded={isOpen(item.id)}
          >
            <span className="dynamicAccordion__title">{item.title}</span>
            <span className="dynamicAccordion__chevron" />
          </button>

          <div className="dynamicAccordion__content">
            <div className="dynamicAccordion__description">
              {item.description}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
